/**
 * Delete issueLinkTypes and $issueLinksMigrated when cleaning up fun-1440_linking_enabled_relay_migration
 */

export const QUERY = `
query JiraBusinessConfiguration($cloudId: ID!, $issueLinksMigrated: Boolean!) {
  jira {
    startDateField: jwmAliasFieldConfig(cloudId: $cloudId, aliasFieldOption: START_DATE) {
      fieldId
      name
    }
    issueLinkTypes(cloudId: $cloudId) @skip(if: $issueLinksMigrated) {
      totalCount
    }
  }
}
`;
